import { useState } from "react";
import { PostCard } from "./postCard/postCard";
import { IPagedPosts } from "../models";
import { IModal, Modal } from "../../../common/components/modal/modal";
import PostView from "../postView/postView";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../common/components/loading/loading";

type PostListProps = {
  pagedPosts: IPagedPosts;
  onPageChange: (page: number) => void;
  isLoading: boolean;
};

export const PostList = ({
  pagedPosts,
  onPageChange,
  isLoading,
}: PostListProps) => {
  const [modal, setModal] = useState<IModal>();
  const [commentCount, setCommentCount] = useState<number>();

  const navigate = useNavigate();

  const closeModal = () => {
    setModal({ show: false });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCommentCount = (c: number) => {
    setCommentCount(c);
  };

  const handlePostClick = (postId: string) => {
    if (window.innerWidth <= 760) {
      navigate("/posts/" + postId);
    } else {
      setModal({
        show: true,
        component: (
          <PostView
            postId={postId}
            modal={true}
            sendCommentCount={handleCommentCount}
          />
        ),
        size: "lg",
        onClose: () => closeModal,
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <nav className="flex justify-center mt-8 mb-4">
            <button
              className={`px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 ${
                !pagedPosts.hasPreviousPage
                  ? "cursor-not-allowed opacity-50"
                  : ""
              }`}
              onClick={() => onPageChange(pagedPosts.page - 1)}
              disabled={!pagedPosts.hasPreviousPage}
            >
              Previous
            </button>
          </nav>

          <div className="grid grid-cols-1 gap-6 justify-items-center">
            {pagedPosts.items.map((post) => (
              <PostCard
                key={post.id}
                post={post}
                onClick={handlePostClick}
                commentCount={commentCount || post.comments.length}
              />
            ))}
          </div>

          {/* Pagination */}
          <nav className="flex justify-center mt-8">
            <ul className="inline-flex items-center -space-x-px">
              <li>
                <button
                  className={`px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 ${
                    !pagedPosts.hasPreviousPage
                      ? "cursor-not-allowed opacity-50"
                      : ""
                  }`}
                  onClick={() => {
                    onPageChange(pagedPosts.page - 1);
                    scrollToTop();
                  }}
                  disabled={!pagedPosts.hasPreviousPage}
                >
                  Previous
                </button>
              </li>
              <li>
                <button
                  className={`px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 ${
                    !pagedPosts.hasNextPage
                      ? "cursor-not-allowed opacity-50"
                      : ""
                  }`}
                  onClick={() => {
                    onPageChange(pagedPosts.page + 1);
                    scrollToTop();
                  }}
                  disabled={!pagedPosts.hasNextPage}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
          <Modal
            show={modal?.show}
            component={modal?.component}
            size={modal?.size}
            onClose={closeModal}
          />
        </div>
      )}
    </>
  );
};
